import React from 'react'
import { Edit, SimpleForm, TextInput } from 'react-admin'
import { Container } from '@mui/material'

export const AirDetailEdit = (props) => {
  return (
    <>
      <Container className='mb-2'>
        <Edit title='AirDetail Edit' {...props}>
          <SimpleForm>
            <TextInput disabled source='id' />
            <TextInput source='airline' />
            <TextInput source='date_out' />
            <TextInput source='date_in' />
            <TextInput source='item_id' />
          </SimpleForm>
        </Edit>
      </Container>
    </>
  )
}
